import { useEffect, useState } from 'react'
import { useSaveSlackConfig, useSlackConfig, useTestSlack } from '@/api/hooks/use-notifications'

export function SlackSection(): React.JSX.Element {
  const { data: slackConfig } = useSlackConfig()
  const saveSlack = useSaveSlackConfig()
  const testSlack = useTestSlack()

  const [webhookUrl, setWebhookUrl] = useState(slackConfig?.webhook_url ?? '')
  const [channel, setChannel] = useState(slackConfig?.channel ?? '')
  const [didInit, setDidInit] = useState(false)
  useEffect(() => {
    if (slackConfig && !didInit) {
      setWebhookUrl(slackConfig.webhook_url)
      setChannel(slackConfig.channel)
      setDidInit(true)
    }
  }, [slackConfig, didInit])
  function handleSaveSlack(): void {
    saveSlack.mutate({ webhook_url: webhookUrl, channel, enabled: true, events: [] })
  }

  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <h2 className="text-lg font-semibold text-text-primary">Slack Integration</h2>
      <p className="mt-1 text-sm text-text-secondary">
        Receive alerts directly in your Slack workspace.
      </p>

      <div className="mt-4 space-y-4">
        <div>
          <label htmlFor="slack-webhook" className="block text-sm font-medium text-text-primary">
            Webhook URL
          </label>
          <input
            id="slack-webhook"
            type="url"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            placeholder="https://hooks.slack.com/services/..."
            className="mt-1 w-full rounded-lg border border-surface-3 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
          />
        </div>

        <div>
          <label htmlFor="slack-channel" className="block text-sm font-medium text-text-primary">
            Channel Name
          </label>
          <input
            id="slack-channel"
            type="text"
            value={channel}
            onChange={(e) => setChannel(e.target.value)}
            placeholder="#alerts"
            className="mt-1 w-full rounded-lg border border-surface-3 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
          />
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleSaveSlack}
            disabled={!webhookUrl.trim() || !channel.trim() || saveSlack.isPending}
            className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
          >
            {saveSlack.isPending ? 'Saving...' : 'Save Configuration'}
          </button>
          <button
            type="button"
            onClick={() => testSlack.mutate()}
            disabled={!webhookUrl.trim() || testSlack.isPending}
            className="rounded-lg border border-surface-3 px-4 py-2 text-sm font-medium text-text-primary hover:bg-surface-1 disabled:opacity-50"
          >
            {testSlack.isPending ? 'Sending...' : 'Send Test Alert'}
          </button>
        </div>

        {saveSlack.isSuccess && (
          <div className="rounded-lg bg-green-50 p-3 text-sm font-medium text-green-800">
            Slack configuration saved successfully.
          </div>
        )}
        {testSlack.isSuccess && (
          <div className="rounded-lg bg-green-50 p-3 text-sm font-medium text-green-800">
            Test alert sent to {channel || 'Slack'}.
          </div>
        )}
        {(saveSlack.isError || testSlack.isError) && (
          <div className="rounded-lg bg-red-50 p-3 text-sm font-medium text-red-800">
            Something went wrong. Please try again.
          </div>
        )}
      </div>
    </div>
  )
}
